export type Listener<T> = (value: T) => void;
export type Unsubscribe = () => void;

/**
 * Minimal synchronous pub/sub. Single Responsibility: owns subscriber
 * bookkeeping and fan-out — nothing else. Reusable by any producer.
 */
export class Subject<T> {
  private readonly listeners = new Set<Listener<T>>();

  subscribe(listener: Listener<T>): Unsubscribe {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  emit(value: T): void {
    for (const listener of this.listeners) listener(value);
  }

  clear(): void {
    this.listeners.clear();
  }
}
